import React from "react";

const Wedding4th = () => {
  return (
    <div className="page4-main overflow-hidden">
      <div>
        <img
          className="blur_circle3"
          src="./Assets/blur-circle.png"
          alt="blur"
        ></img>
      </div>

      <div>
        <img
          className="blur_circle4"
          src="./Assets/blur-circle.png"
          alt="blur"
        ></img>
      </div>
      <div className="wedding4-heading">
        <h1 className="wedding4-header">WEDDING FESTIVITIES</h1>
        <div>
          <img
            className="wedding4heading-img"
            src="./Assets/experience-logo.webp"
            alt="img"
          ></img>
        </div>
      </div>
      <div className="wedding4middle">
        <div className="leftarrow">
          <img src="./Assets/leftarrow.png" alt="img"></img>
        </div>
        <div>
          <img
            className="wedding4-main-img"
            src="./Assets/wedding_page4_img_big.webp"
            alt="img"
          ></img>
        </div>
        <div className="wedding4main-text">
          <h1 className="Haldi">Haldi</h1>

          <p className="wedding4-text">
            Lorem ipsum dolor sit amet consectetur. Adipiscing lectus sit sit
            sed semper vitae faucibus consequat. Sed dui auctor aliquam quam
            urna magna feugiat egestas placerat. Pharetra arcu nulla lacus
            molestie quis dignissim quis tempor interdum. Quam blandit iaculis
            ante pellentesque lectus viverra tristique ultrices. Adipiscing
            purus mattis leo sit mi id sed. Eleifend sed enim odio sapien
            tincidunt viverra. Interdum congue eu bibendum tellus odio.
            Ridiculus posuere ut id imperdiet lorem. Pellentesque turpis mi cras
            vel risus blandit elementum
          </p>
        </div>
        <div className="rightarrow-container">
          <img
            className="rightarrow"
            src="./Assets/leftarrow.png"
            alt="img"
          ></img>
        </div>
      </div>
      <div className="wedding-bottom">
        <div className="wedding-bottom-img-container">
          <img
            src="./Assets/wedding_page4_img1.webp"
            className="wedding-bottom-img"
            alt="img"
          ></img>
        </div>
        <div className="wedding-bottom-img-container">
          <img
            src="./Assets/wedding_page4_img2.webp"
            className="wedding-bottom-img"
            alt="img"
          ></img>
        </div>
        <div className="wedding-bottom-img-container">
          <img
            src="./Assets/wedding_page4_img3.webp"
            className="wedding-bottom-img"
            alt="img"
          ></img>
        </div>
        <div className="wedding-bottom-img-container">
          <img
            src="./Assets/wedding_page4_img4.webp"
            className="wedding-bottom-img"
            alt="img"
          ></img>
        </div>
        <div className="wedding-bottom-img-container">
          <img
            src="./Assets/wedding_page4_img5.webp"
            className="wedding-bottom-img"
            alt="img"
          ></img>
        </div>
        <div className="wedding-bottom-img-container">
          <img
            src="./Assets/wedding_page4_img6.webp"
            className="wedding-bottom-img"
            alt="img"
          ></img>
        </div>
        <div className="wedding-bottom-img-container">
          <img
            src="./Assets/wedding_page4_img7.webp"
            className="wedding-bottom-img"
            alt="img"
          ></img>
        </div>
        <div className="wedding-bottom-img-container">
          <img
            className="wedding-bottom-img"
            src="./Assets/wedding_page4_img8.webp"
            alt="img"
          ></img>
        </div>
      </div>
      <p className="viewall">View All</p>
    </div>
  );
};

export default Wedding4th;
